module.exports = __webpack_public_path__ + "media/operational-monitoring_de_ipad_old.c6e3406e.mp4";